import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

export const StarRatingPicker = ({ rating, setRating, hover, setHover }) => {
  return (
    <div className="d-flex align-items-center justify-content-center gap-2 py-3">
      {[1, 2, 3, 4, 5].map((starIndex) => {
        const isFilled = (hover || rating) >= starIndex;
        return (
          <motion.button
            key={starIndex}
            type="button"
            whileHover={{ scale: 1.25 }}
            whileTap={{ scale: 0.9 }}
            className="btn btn-link p-1 border-0 text-decoration-none"
            onClick={() => setRating(starIndex)}
            onMouseEnter={() => setHover(starIndex)}
            onMouseLeave={() => setHover(0)}
            style={{ cursor: 'pointer', background: 'transparent' }}
          >
            <Star
              size={32}
              style={{
                fill: isFilled ? 'var(--bry-accent, #0EABB0)' : 'transparent',
                color: isFilled ? 'var(--bry-accent, #0EABB0)' : 'rgba(255, 255, 255, 0.25)',
                transition: 'all 0.15s ease'
              }}
            />
          </motion.button>
        );
      })}
    </div>
  );
};

export default StarRatingPicker;
